import { useTranslation } from "react-i18next";
import { Box, ContentRepeater, Icon } from "../../common/components";
import { Typography } from "@mui/material";
import { createStyles, gradient, palette, spacing } from "../../styles/theme";
import { memo, useEffect, useState } from "react";
import useExternalRoute from "../../utils/useExternalRoute";

const styles = createStyles({
  container: {
    p: "16px",
    display: "flex",
    flexDirection: "column",
    gap: spacing.smallDesktop,
    background: `${gradient.backgroundGradient}, ${palette.lightBorderGradient}`,
    borderRadius: "8px",
    border: "1px solid transparent",
  },
});

const WorkWithADesignerMessage = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const { TRANSLATED_EXTERNAL_ROUTE } = useExternalRoute();

  useEffect(() => {
    const checkVisibility = () => {
      const lastShown = localStorage.getItem("designerMessageLastShown");
      const now = new Date();
      if (
        !lastShown ||
        now.getTime() - new Date(lastShown).getTime() >= 3600000 //check if 1 hour has passed
      ) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    checkVisibility();
    const intervalId = setInterval(checkVisibility, 60000); // Check every minute

    return () => clearInterval(intervalId); // Cleanup on unmount
  }, []);

  if (!visible) return null;

  return (
    <Box
      sx={{ position: "absolute", bottom: "19px", right: "12px", left: "12px" }}
    >
      <Box sx={styles.container}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="textRegularBold">
            {t("design.meet_a_designer_title")}
          </Typography>
          <Icon
            icon={"close"}
            size={18}
            color={palette.grey.primary}
            onClick={() => {
              localStorage.setItem(
                "designerMessageLastShown",
                new Date().toString()
              );
              setVisible(false);
            }}
          />
        </Box>
        <Typography variant="textSm" color={palette.grey.primary}>
          {t("design.meet_a_designer_message")}
        </Typography>

        <Box gap={spacing.smallDesktop} display={"flex"}>
          <Box
            display={"flex"}
            sx={{
              "& span:last-of-type": {
                clipPath: "inset(0 3px 0 0)",
              },
            }}
            maxWidth={"fit-content"}
            marginRight={"-3px"}
          >
            <ContentRepeater repeatCount={5}>
              <Icon icon={"star"} color={"#FDB022"} size={12} filled />
            </ContentRepeater>
          </Box>
          <Typography
            variant="textSm"
            fontWeight={600}
            color={palette.grey.nearBlack}
          >
            4.8
          </Typography>
          <Typography variant="textSm" color={palette.grey.primary}>
            {t("design.meet_a_designer_review")}
          </Typography>
        </Box>

        <Box
          display={"flex"}
          alignItems={"center"}
          onClick={() => {
            window.open(TRANSLATED_EXTERNAL_ROUTE.WORK_WITH_DESIGNER, "_blank");
          }}
          sx={{
            color: palette.blue.secondary,
            width: "fit-content",
            cursor: "pointer",
            "&:hover": {
              "& > span:first-of-type": {
                textDecoration: "underline",
              },
            },
          }}
        >
          <Typography variant="textSm" color={palette.blue.secondary}>
            {t("navigation.work_with_designer")}
          </Typography>
          <Icon
            icon={"trending_flat"}
            size={13}
            color={palette.blue.secondary}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default memo(WorkWithADesignerMessage);
